import React from 'react';

export interface BottomMenuContextProps {
  selectedTab: string,
  handleOpen: Function,
  myBetsCount: number
}

const BottomMenuContext = React.createContext<Partial<BottomMenuContextProps>>({
  selectedTab: '',
  handleOpen: () => {},
  myBetsCount: 0
});

export default BottomMenuContext;
